import React, { useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { message, Modal, Checkbox } from 'antd'
import { listLocal } from '../../../helpers/filtersTable'
import formatNumber from '../../../helpers/formatNumber'
import { genLabelCombineShip, updateCombineShip } from '../../../../services/api/apiCombineShip'
import iconQrCode from '../../../../assets/images/icon-qr-code.png'

function CombineShipRow(props) {

    const { item, reload, userRoles, arrSelected, onSelected, onGetInfoBox } = props
    const {
        id, _id,
        created,
        updated,
        status,
        batch_type,
        line_ship,
        completed_barcode_count = {},
        dimension = {},
        label,
        barcodes, tags = [],
    } = item

    const [showModal, setShowModal] = useState(false)
    const [confirmWarning, setConfirmWarning] = useState([])
    const [showModalGenLabel, setShowModalGenLabel] = useState(false)
    const [genLabelWarning, setGenLabelWarning] = useState('')
    const [showModalViewLabel, setShowModalViewLabel] = useState(false)
    const [showAll, setShowAll] = useState(false)
    const [loading, setLoading] = useState(false)
    const [forceConfirm, setForceConfirm] = useState(false)

    const handleToggleModal = (e) => {
        e.preventDefault()
        setShowModal(!showModal)
        setConfirmWarning([])
    }

    const _handleConfirmCombineShip = async () => {
        const payload = {
            status: 'confirmed'
        }

        try {
            const { data } = await updateCombineShip(_id, payload)
            const { success, message: mess, data: Data } = data
            const { errors } = { ...Data }
            if (success && !errors) {
                message.success('Trạng thái đơn confirmed')
                setShowModal(false)
                reload()
            } else {
                setConfirmWarning(errors || [])
                !!mess && message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    const handleToggleModalGenlabel = (e) => {
        e.preventDefault()
        setShowModalGenLabel(!showModalGenLabel)
        setGenLabelWarning('')
    }

    const _handleGenlabel = async (id) => {
        setLoading(true)
        try {
            const response = await genLabelCombineShip(id)
            const { success, message: mess, data: Data } = response || {}
            const { errors } = { ...Data }
            if (success && !errors) {
                message.success('Gen label thành công!')
                setShowModalGenLabel(false)
                reload()
            } else {
                setGenLabelWarning(errors || '')
                !!mess && message.error(mess)
            }
        } catch (error) {
            if (error.status === 403) {
                message.error("Bạn không có quyền gen label.")
            }else{
                message.error(error.message)
            }
        }finally{
            setTimeout(() => setLoading(false), 1000)
            setShowModalGenLabel(false)
        }
    }

    const handleToggleViewlabel = (e) => {
        e.preventDefault()
        setShowModalViewLabel(!showModalViewLabel)
    }

    const checkValue = (value) => {
        return !!value ? value : '-'
    }

    const ShippingCarrierName = (carrier) => {
        if (!!carrier) {
            const mappingCarriers = [
                ...listLocal,
                { value: 'usps_mn_ib_blue', name: 'USPS MN/IB Blue' },
                { value: 'ib_blue_usps_mn', name: 'IB Blue/USPS MN' },
            ]
            const shippingName = mappingCarriers.filter(item =>!!item.value && item.value === carrier)
            return !!shippingName.length ? shippingName[0].name : ''
        }
    }

    const _detectChecked = () => {
        return Array.isArray(arrSelected) && !!arrSelected.find(i => i._id === _id)
    }

    const _handleChange = () => {
        const isChecked = _detectChecked()

        if (typeof onSelected === 'function') {
            onSelected(_id, !isChecked)
        }
    }

    const _handleClickEdit = () => {
        onGetInfoBox(id, dimension.weight, dimension.height, dimension.width, dimension.length)
    }

    const copyToClipboard = () => {
        const textToCopy = barcodes.join("\n"); // Nối item thành chuỗi có xuống dòng
        navigator.clipboard.writeText(textToCopy)
            .then(() => message.success("Copied to clipboard!"))
            .catch((err) => console.error("Copy failed:", err));
    };

    const isPDF = (url) => {
        return /\.pdf(\?|$)/i.test(url);
    }

    const adminPermission = !!userRoles.length && userRoles.includes('fac_admin')
    const ffmPermission = !!userRoles.length && userRoles.includes('fac_ffm')
    const isChecked = _detectChecked()

    const visibleBarcodes = showAll ? barcodes : barcodes.slice(0, 3);

    return (
        <tr>
            <td>
                <div className='d-flex flex-column'>
                    <Link to={`/combine-ship/${_id}`} className='mr-2'>{id}</Link>
                    {batch_type === 'FBA' &&
                        <button type="button" className="ant-btn TagFBA ant-btn-primary ant-btn-sm">
                            <span>FBA</span>
                        </button>
                    }
                    
                    <ul onClick={copyToClipboard} className='list-barcodes'>
                        {visibleBarcodes.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    {barcodes.length > 3 && (
                        <span onClick={() => setShowAll(!showAll)} style={{fontSize: '12px', color: '#2196F3', cursor: 'pointer'}}>
                            {showAll ? "Show Less" : "Show More"}
                        </span>
                    )}
                </div>
            </td>
            <td>{moment(created).format('HH:mm DD/MM/YYYY')}</td>
            <td>{moment(updated).format('HH:mm DD/MM/YYYY')}</td>
            <td
                style={{ color: (
                    status === 'in_production' ? '#e28743'
                    : status === 'cancelled' ? '#F44336'
                    : status === 'shipped' ? '#2196F3'
                    : '#28A745'
                ) }}
            >
                {status === 'in_production' ? 'in production' : status}
            </td>
            <td>{line_ship}</td>
            <td>{completed_barcode_count && completed_barcode_count.total ? completed_barcode_count.total : ''}</td>
            <td className={`${completed_barcode_count && completed_barcode_count.completed === completed_barcode_count.total ?'text-success' : 'text-danger'}`}>{completed_barcode_count ? `${completed_barcode_count.completed ? completed_barcode_count.completed : '0'}/${completed_barcode_count.total ? completed_barcode_count.total : '0'}` : '-'}</td> 
            <td>
                {
                    line_ship !== 'SB_FAST' &&
                    <>
                        <span className="weight">{typeof dimension.weight !== 'undefined' && dimension.weight}{typeof dimension.weight !== 'undefined' ? ' KG' : ''}</span>
                        {(typeof dimension.width !== 'undefined' || typeof dimension.height !== 'undefined' || typeof dimension.length !== 'undefined') ? <span className="clearfix" /> : ''}
                        <span className="size">
                            {typeof dimension.length !== 'undefined' ? dimension.length : ''}{typeof dimension.length !== 'undefined' && 'cm x '}{typeof dimension.width !== 'undefined' ? dimension.width : ''}{typeof dimension.width !== 'undefined' && 'cm x '}{typeof dimension.height !== 'undefined' ? dimension.height : ''}{typeof dimension.height !== 'undefined' && 'cm'}
                            {/* <span onClick={_handleClickEdit}>
                            <i className='icon-pencil' />
                        </span> */}
                        </span>
                    </>
                }
            </td>
            <td>
                {status === 'completed' &&
                    <>
                    <span className='Action mx-1 cursor-pointer' onClick={handleToggleViewlabel}>
                        <img src={iconQrCode} alt="View label"/>
                    </span>

                    <Modal
                        title='View label'
                        visible={showModalViewLabel}
                        onCancel={handleToggleViewlabel}
                        okButtonProps={{ style: { display: 'none' } }}
                        classNames='ModalViewLabel'
                        width={800}
                        >
                        {
                            label && label.url &&
                            <div className='ViewLabelBox'>
                                {
                                    isPDF(label.url) ? <iframe src={label.url} width="100%" height="600px"></iframe> : 
                                    <img src={label.url} alt="label" style={{maxWidth: '100%'}}/>
                                }
                            </div>
                        }
                    </Modal>

                    {
                        line_ship !== 'SB_FAST' &&
                        <>
                        <Link
                            className='Action mx-1'
                            onClick={handleToggleModalGenlabel}
                            to=''
                        >
                            Gen label
                        </Link>

                        <Modal
                            title='Xác nhận gen label'
                            visible={showModalGenLabel}
                            onOk={() => _handleGenlabel(_id)}
                            onCancel={handleToggleModalGenlabel}
                            okButtonProps={{ disabled: ((genLabelWarning || loading) ? true : false )}}
                            >
                            {
                                !genLabelWarning.length &&
                                <label className='text-danger'>
                                    Có chắc chắn muốn gen label cho đơn gộp ship '{id}'!!!
                                </label>
                            }
                            { 
                                genLabelWarning &&
                                <span className='text-danger'>
                                    {genLabelWarning}
                                </span>
                            }
                        </Modal>
                        </>
                    }
                    </>
                }
                {status === 'confirmed' && line_ship !== 'SB_FAST' &&
                    <>
                    <Link
                        className='Action mx-1'
                        onClick={handleToggleModalGenlabel}
                        to=''
                    >
                        Gen label
                    </Link>

                    <Modal
                        title='Xác nhận gen label'
                        visible={showModalGenLabel}
                        onOk={() => _handleGenlabel(_id)}
                        onCancel={handleToggleModalGenlabel}
                        okButtonProps={{ disabled: ((genLabelWarning || loading) ? true : false )}}
                        >
                        {
                            !genLabelWarning.length &&
                            <label className='text-danger'>
                                Có chắc chắn muốn gen label cho đơn gộp ship '{id}'!!!
                            </label>
                        }
                        { 
                            genLabelWarning &&
                            <span className='text-danger'>
                                {genLabelWarning}
                            </span>
                        }
                    </Modal>
                    </>
                }
                {status === 'in_production' &&
                    <>
                        <Link
                            className='Action mx-1'
                            onClick={handleToggleModal}
                            to=''
                            disabled={tags.includes('combo_fac')}
                        >
                            Confirm
                        </Link>|
                        <Link
                            className='Action mx-1'
                            to={`/combine-ship/${_id}`}
                        >
                            Edit
                        </Link>
                        <Modal
                            title='Xác nhận hoàn thành đơn gộp ship'
                            visible={showModal}
                            onOk={_handleConfirmCombineShip}
                            onCancel={handleToggleModal}
                            okButtonProps={{ disabled: (confirmWarning.length > 0 && !confirmWarning.every(i => i.type === 'warning')) }}
                        >
                            {confirmWarning.length <= 0 &&
                                <label className='text-danger'>
                                    Đơn gộp ship '{id}' sẽ được chuyển sang trạng thái confirmed!!!
                                </label>
                            }
                            {confirmWarning.length > 0 &&
                                confirmWarning.map(i =>
                                (<label
                                    className={(i.type === 'error' ? 'text-danger' : 'text-warning') + ' w-100 mt-1'}
                                    style={{ whiteSpace: "pre-line" }}
                                >
                                    <i className={i.type === 'error' ? 'icon-cancel-circle2' : 'icon-warning22'} /> {i.msg}
                                </label>)
                                )
                            }
                        </Modal>
                    </>
                }
            </td>
        </tr>
    )
}

export default CombineShipRow